<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.24 29.98">
    <g id="Calque_2" data-name="Calque 2">
      <g id="ƒŒƒCƒ_1" data-name="ƒŒƒCƒ„[ 1">
        <path
          class="cls-1"
          d="M29.59,18.51a.65.65,0,0,0,.65-.65V12.12a.65.65,0,0,0-.65-.65H24.24V6.39a.66.66,0,0,0-.65-.66H18.77V.65A.65.65,0,0,0,18.12,0H.65A.65.65,0,0,0,0,.65V29.33A.65.65,0,0,0,.65,30H29.59a.65.65,0,0,0,.65-.65V23.59a.65.65,0,0,0-.65-.65H24.24V18.51Zm-.66-1.31H18.77V12.77H28.93ZM17.47,15.76a15.18,15.18,0,0,0-2.06-3h2.06Zm5.47-4.29H14a14,14,0,0,0-1.26-.9V7H22.94ZM1.3,7H11.47v2.8A29,29,0,0,0,1.3,7.35ZM17.47,5.73H7.3V1.3H17.47ZM1.3,1.3H6V5.73H1.3Zm0,27.37v-20C13.61,9.84,15.54,14.32,17.77,19.5c1.26,2.93,2.67,6.2,6.05,9.17Zm27.63,0h-3a17.56,17.56,0,0,1-4.25-4.43h7.29Zm-6-5.73h-2.1A42.93,42.93,0,0,1,19,19l-.2-.47h4.18Z"
        />
        <path class="cls-2" d="M1.3,28.64v-20c12.31,1.18,14.24,5.66,16.47,10.84,1.26,2.93,2.67,6.21,6.05,9.17Z" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconMaterial',
};
</script>

<style scoped>
.cls-1 {
  fill: #162b46;
}
.cls-2 {
  fill: #f9802f;
}
</style>
